import React, {FC} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IDisplayUser } from '../../../common/async/AsyncCalls';
import { IUserState } from '../../../common/state/profile/user';
import { GENERAL_INFO_ACTION_TYPE, IGeneralInfoState } from '../../../common/state/subscriptions/general_info';
import { IPaymentInfo, IPaymentInfoState, PAYMENT_INFO_ACTION_TYPE } from '../../../common/state/subscriptions/payment_info';
import { IPersonalInfo, IPersonalInfoState, PERSONAL_INFO_ACTION_TYPE } from '../../../common/state/subscriptions/personal_info';
import NavbarUser from '../../../components/navbar/Navbar.user';
import StepperPanel, { useStepper } from '../../../components/stepper/Stepper.panel';
import BillingInfoForm from './panels/BillingInfoForm';
import CheckoutForm from './panels/CheckoutForm';
import PaymentSelectionForm from './panels/PaymentSelectionForm';
import PersonalInfoForm from './panels/PersonalInfoForm';
// custom

const OnlineRegisterView : FC = () => {

    // states
    const userProfile: IDisplayUser = useSelector(({user}:{user: IUserState}) => user.profile);
    const eventTitle: string | undefined = useSelector(({general_info}:{general_info: IGeneralInfoState}) => general_info.selected?.event_title);
    const personalInfo: IPersonalInfo | undefined = useSelector(({personal_info}:{personal_info: IPersonalInfoState}) => personal_info.selected);
    const paymentInfo: IPaymentInfo | undefined = useSelector(({payment_info}:{payment_info: IPaymentInfoState}) => payment_info.selected);
    const {steps, currentStep, setCurrentStep, complete} = useStepper([
        "Personal Info", "Payment Selection", "Billing Info", "Checkout"]);
    const generalInfoState = useSelector(({general_info} : {
        general_info: IGeneralInfoState
    }) => general_info.selected);

    // actions
    const generalInfoDispatch : (data : {type: GENERAL_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();
    const personalInfoDispatch: (data: {type: PERSONAL_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();
    const paymentInfoDispatch: (data: {type: PAYMENT_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();

    // evt handlers - prev
    function handlePreviousPanel () {
        setCurrentStep(curr => curr > 0 ? curr - 1 : 0);
    }

    // evt handlers - personal info
    function handlePersonalInformation (data: IPersonalInfo) {        
        personalInfoDispatch({type: PERSONAL_INFO_ACTION_TYPE.INFO_SELECT, payload: data});
        setCurrentStep(curr => curr + 1);
    }

    // evt handlers - personal info
    function handleBillingInformation (data: IPaymentInfo) {
        console.log('Billing information: ', data);
        paymentInfoDispatch({type: PAYMENT_INFO_ACTION_TYPE.INFO_SELECT, payload: data});
        setCurrentStep(curr => curr + 1);
    }

    // evt handlers - payment selection | next
    function handlePaymentSelection (finalPrice: number) {
        if (finalPrice > 0) {
            generalInfoDispatch({type: GENERAL_INFO_ACTION_TYPE.FINAL_PRICE_UPDATE, payload: finalPrice});            
            setCurrentStep(curr => curr + 1);
        }
    }

    


    // did mount
    // useEffect(()=>{
    //     console.log('General info so far: ', generalInfoState);
    // },[generalInfoState]);

    return <React.Fragment>
        <NavbarUser />
        <main
            className="flex flex-col items-center justify-start h-screen overflow-y-scroll text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dartext-base">
                <p className="p-4 my-4 text-gray-700 dark:text-gray-300 dartext-base">
                    Register for <strong>{eventTitle}</strong>, complete four simple steps and you are done !
                </p>
                {/* <CheckoutForm/> */}
                <StepperPanel steps={steps} currentStep={currentStep} complete={complete}>
                    {currentStep === 1 ? <PersonalInfoForm 
                        defaultFormData={personalInfo ? personalInfo: {
                            first_name: generalInfoState?.reg_type === 'self' ? userProfile.name?? '' : '',
                            last_name: '',
                            email: generalInfoState?.reg_type === 'self' ? userProfile.email?? '': '',
                            contact: '',
                            address: '',
                            city: '',
                            country: '',
                            pin_code: '',
                            passport: ''
                        }} 
                        onSubmit={handlePersonalInformation}/> : 
                    currentStep === 2 ? <PaymentSelectionForm
                    onSubmit={handlePaymentSelection}
                    onBack={handlePreviousPanel}/> : currentStep === 3 ? <BillingInfoForm defaultFormData={paymentInfo ? paymentInfo: {
                        first_name: userProfile.name?? '',
                        last_name: '',
                        email: userProfile.email?? '',
                        contact: '',
                        address: '',
                        city: '',
                        country: '',
                        pin_code: '',                            
                    }} 
                    onSubmit={handleBillingInformation}
                    onBack={handlePreviousPanel}/> : <CheckoutForm/>}                    
                </StepperPanel>            
        </main>
    </React.Fragment>
};

export default OnlineRegisterView;